if (!customElements.get('sticky-atc')) {
  class StickyATC extends HTMLElement {
    constructor() {
      super();

      this.isScrolledPastAtc = false;
      this.isMainAtcVisible = true;
      this.onScroll = this.onScroll.bind(this);
      this.handleUpperIntersect = this.handleUpperIntersect.bind(this);
    }

    variantChangeUnsubscriber = undefined;

    connectedCallback() {
      // Initialize Intersection Observer
      this.initializeIntersectionObserver();

      // Add event listeners
      this.addEventListeners();

      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        this.variantSelector.querySelectorAll('variant-selects select').forEach((select, index) => {
          select.value = event.data.variant.options[index]
        })

        if (this.variantSelector.querySelector('select[name="id"]')) {
          this.variantSelector.querySelector('select[name="id"]').value = event.data.variant.id
        }
      })
    }

    // Initialize Intersection Observer
    initializeIntersectionObserver() {
      this.stickyATCUpper = document.querySelector('.section-main-product .product-form__buttons');
      if (!this.stickyATCUpper) return;

      this.intersectionObserver = new IntersectionObserver(this.handleUpperIntersect, {
        threshold: 0.2,
      });
      this.intersectionObserver.observe(this.stickyATCUpper);

      document.documentElement.style.setProperty('--footer-offset', `${this.offsetHeight}px`);
    }

    // Add event listeners
    addEventListeners() {
      this.colorSelector = this.querySelector('.product__color-selector');
      this.variantSelector = this.querySelector('.product__variant-selector');

      this.colorSelectorDrawerListener();
      this.variantSelectorListener();
      this.scrolledPastAtc();

      this.button = this.querySelector('[data-sticky-atc-btn]');
      this.button.addEventListener('click', this.onClickHandler.bind(this));

      this.mobileButton = this.querySelector('.mobile-trigger button');
      this.mobileButton?.addEventListener('click', this.onClickHandlerMobile.bind(this));
    }

    // Remove event listeners
    removeEventListeners() {
      this.colorSelector = this.querySelector('.product__color-selector');
      this.variantSelector = this.querySelector('.product__variant-selector');

      this.colorSelector?.removeEventListener('click', this.colorSelectorDrawerListener);
      this.variantSelector?.removeEventListener('click', this.variantSelectorListener);

      window.removeEventListener('scroll', this.onScroll);

      this.button.removeEventListener('click', this.onClickHandler.bind(this));
      this.mobileButton?.removeEventListener('click', this.onClickHandlerMobile.bind(this));
    }

    // Method to reinitialize event listeners and Intersection Observer
    reinitialize() {
      this.intersectionObserver.disconnect();
      this.removeEventListeners();

      this.addEventListeners();
      this.initializeIntersectionObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);

      if (!this.stickyATCUpper) return;

      this.intersectionObserver?.disconnect();

      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    handleUpperIntersect(entries) {
      this.colorSelector = this.querySelector('.product__color-selector');
      this.variantSelector = this.querySelector('.product__variant-selector');

      entries.forEach((entry) => {
        this.isMainAtcVisible = entry.isIntersecting;
        this.updateVisibility();

        this.variantSelector?.classList.remove('active');
        this.colorSelector?.classList.remove('active');
      });
    }

    isNearPageBottom() {
      const threshold = this.offsetHeight + 5;
      const remaining = document.documentElement.scrollHeight - (window.scrollY + window.innerHeight);
      return remaining <= threshold;
    }

    updateVisibility() {
      const hideTransform = 'translateY(calc(100% + var(--layout-space-24)))';
      const shouldShow = this.isScrolledPastAtc && !this.isMainAtcVisible && !this.isNearPageBottom();

      this.style.transform = shouldShow ? 'translateY(0)' : hideTransform;

      document.querySelector('button.needsclick[aria-label="Open Form"]')
        ?.classList.toggle('show-newsletter-button-PDP', shouldShow);
    }

    colorSelectorDrawerListener() {
      // Color Selector Drawer Listener
      this.colorSelector?.querySelector('.product__color-selector--wrapper').addEventListener('click', () => {
        this.colorSelector.classList.toggle('active');
        this.variantSelector?.classList.remove('active');
      });
    }

    variantSelectorListener() {
      // Variant Selector Listener
      this.variantSelector?.querySelector('.product__variant-selector--wrapper').addEventListener('click', () => {
        this.variantSelector.classList.toggle('active');
        this.colorSelector?.classList.remove('active');
      });
    }

    scrolledPastAtc() {
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    onScroll() {
      if (!this.stickyATCUpper) return;

      this.isScrolledPastAtc = window.scrollY > this.stickyATCUpper.offsetTop;
      this.updateVisibility();
    }

    onClickHandler(event) {
      // Click Handler
      event.preventDefault();
      const mainAtc = document.querySelector('.product-form .product-form__submit');
      if (mainAtc) {
        mainAtc.click();
      }
    }

    onClickHandlerMobile(event) {
      // Mobile Click Handler
      event.preventDefault();
      if (window.innerWidth < 750) {
        this.stickyATCUpper.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
      }
    }
  }

  customElements.define('sticky-atc', StickyATC);
}
